<div class="dashboard row">
  <div>
    <img class="dashboard-logo" src="./../../assets/images/dashboard/dashboard-logo.png">
    <div class="dropdown profile">
        <img *ngIf="notification_available && notification_icon" class="notification" (click)="notificationOpen()" src="./../../../assets/images/navBarIcons/notification.svg">
        <img *ngIf="!notification_available && notification_icon" class="notification" (click)="notificationOpen()" src="./../../../assets/images/navBarIcons/notification_inactive.svg">
        <a *ngIf="user_name" class="dropdown-toggle" role="button" id="dropdownMenu2" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" >
            <img class="" role="button" src="./../../../assets/images/navBarIcons/circle-user-regular.svg" >
        </a>
        <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenu2">
          <button class="dropdown-item disabled profile-name" type="button">{{user_name}}</button>
          <button class="dropdown-item disabled profile-position" type="button">{{role_name}}</button>
          <div class="dropdown-divider"></div>
          <button class="dropdown-item logout" type="button" (click)="logout()">
            <img src="./../../assets/images/dashboard/Icon ionic-ios-log-out.svg">
            Logout
        </button>
        </div>
      </div> 
    <img class="logo" src="./../../../assets/images/logo/logo.png">
    <div *ngIf="selected_market"  class="dropdown logo market-logo market_dropdown">
      <a class="dropdown-toggle" href="#" id="marketDropdown" data-toggle="dropdown" aria-haspopup="true"
      aria-expanded="false">
      <img [src]='market_icon[selected_market]' [alt]="selected_market" class="img-fluid" [title]="selected_market" />
      <span class="caret ml-1"></span>
      <div class="dropdown-menu dropdown-menu-left" aria-labelledby="marketDropdown">
        <div *ngFor="let market of market_options">
          <span class="dropdown-item" (click)="selected_market = market;  onMarketChange()" [class.active]="market === selected_market">
            {{country_name[market]}}
          </span>
        </div>
      </div>
    </a>
    </div>
    <div class="dashboard_main">
    <div class="logo-text">
      <h1>
       {{"lang.dashboard.welcome" | translate}}
      </h1>
      <h4>
       {{'lang.dashboard.description' | translate}}
      </h4>
    </div>
    <div *ngIf="selected_market" class="component-grid">
      <app-dashboard-card *ngFor="let i of dashboard_data" [code]="i.navigation_code" [name]="i.navigation_name"
        [link]="i.link"></app-dashboard-card>
    </div>
    <div *ngIf="!selected_market" class="component-grid">
      <app-dashboard-card *ngFor="let market of market_options" [name]="country_name[market]" [code]="market"
        (click)="selected_market = market;onMarketChange()"></app-dashboard-card>
    </div>
    <p class="card_info" *ngIf="selected_market">{{"lang.dashboard.card_click_text" | translate}}</p>
    <p class="card_info" *ngIf="!selected_market">{{"lang.dashboard.select_market_text" | translate}}</p>
    </div>
    </div>
</div>